import { render, staticRenderFns } from "./BumpsLocation.vue?vue&type=template&id=0bed06ba"
import script from "./BumpsLocation.vue?vue&type=script&lang=js"
export * from "./BumpsLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports